<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-12 nopads list-container">
        <div v-if="resultList.length > 0" class="list-content result-table" :class="{nopads : noPadding}">
            <vue3-datatable
                :rows="resultList"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                :height="resultList.length > 8 ? '50vh' : '100%'"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
                @row-click="rowClicked"
            >
                <template #active="row">
                    {{ row.value.active ? $t('common.yes') : $t('common.no') }}
                </template>
                <template #sanction_account="row">
                    {{ row.value.sanction_account ? $t('common.yes') : $t('common.no') }}
                </template>
            </vue3-datatable>
        </div>
    </div>
</template>

<script>
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'account-list',
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        noPadding: {
            type: Boolean,
            default: false
        },
        tableSortable: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {
            resultList: []
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        },
        fields() {
            return [
                {field: 'code', title: this.$t('account.account_number'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'name', title: this.$t('account.account'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'active', title: this.$t('account.active'), sort: this.tableSortable, headerClass: 'routa-table-header'},
                {field: 'sanction_account', title: this.$t('account.sanction_account'), sort: this.tableSortable, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        results() {
            this.initResults()
        }
    },
    mounted() {
        this.initResults()
    },
    methods: {
        initResults() {
            let temp = []
            this.resultList = []
            this.results.forEach(item =>
                temp.push({
                    'id': item.id,
                    'company': item.company,
                    'name': item.name,
                    'code': item.code,
                    'active': item.active,
                    'sanction_account': item.sanction_account
                })
            )
            this.$nextTick(() => this.resultList = temp )
        },

        rowClicked: function (item) {
            const clickedItem = this.results.find(result => result.id === item.id)
            if (clickedItem) {
                this.$emit("rowClicked", clickedItem)
            }
        }
    }
}
</script>
